// LoadingSpinner.js
import React from 'react';
import './LoadingSpinner.css'; // Create a CSS file for styling if needed

const LoadingSpinner = ({ message }) => {
  return (
    <div className="loading-spinner">
      <div className="spinner-border" role="status">
        <span className="sr-only">Loading...</span>
      </div>
      {message && <p>{message}</p>}
    </div>
  );
};

export default LoadingSpinner;